import { Bar } from 'vue-chartjs'
import {mapState} from "vuex";
export default {
    extends: Bar,
    mounted () {
        let datas = this.datas.transactions_by_week_date;
        console.log(datas,'********')
        let days = [];
        let amounts = [];
        for(let index in datas){
            let data = datas [index];
            days.push(data.day);
            amounts.push(data.totalAmount);
        }

        // Overwriting base render method with actual data.
        this.renderChart({
            //labels: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
            labels: days,
            datasets: [
                {
                    label: 'Quand suis-je le plus payé',
                    backgroundColor: '#41B883',
                    data: amounts
                }
            ]
        })
    },
    computed:{
        ...mapState('dashboard',['datas']),
        ...mapState('means_paiements/', ['means_paiements']),
    }

}
